import { DatePipe } from '@angular/common';
import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
// Firebase
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Usuario } from '../interfaces/book.interface';
import { AuthService } from './auth.service';
import { Plugins } from '@capacitor/core';

const { Geolocation } = Plugins;

@Injectable()

export class FirebaseService implements OnDestroy {

  private subscriptionUbicacion: Subscription = new Subscription();

  // Parametros 
  getID: string = null;
  authCiudad: string = null;

  appUbicacion = {
    lat: null,
    lng: null
  };

  usuarioApp: Usuario;

  tiempoRecargaMapa = 9000;
  tiempoRecargaUbicacion = 20000;

  fechaActual: any;
  fechaActualObj: any;
  fechaDia: any;
  fechaMes: any;
  fechaYear: any;
  fechaHora: any;
  fechaMinuto: any;

  actualizarUbicacion: any;

  constructor(
    private FireStore: AngularFirestore,
    private auth: AuthService,
    public datepipe: DatePipe
  ) {
    this.establecerFecha(); // Fecha Actual
    this.auth.getUidState().subscribe(user => {
      if (user !== null && user !== undefined) {
        const uid = user.uid;
        console.log('User id ->', uid);
        const path = '/usuarios/' + user.uid;
        this.getDoc<Usuario>(path).subscribe(async data => {
          console.log('User data->', data);
          if (data !== null && data !== undefined) {
            this.authCiudad = data.ciudad;
            console.log('Ciudad App -> ', this.authCiudad);
            //console.log('Fecha Formateada -> ', this.getFechaYear() + '-' + this.getFechaMesActual() + '-' + this.getFechaDia());
            this.usuarioApp = data;
          }
        });
      }
      this.actualizarUbicacion = interval(this.getTRecargaUbicacion());
      this.subscriptionUbicacion.add(
        this.actualizarUbicacion.subscribe(() => {
          this.getParametroUbicacion();
        })
      );
    });


  }

  ngOnDestroy() {
    this.subscriptionUbicacion.unsubscribe();
    clearInterval(this.actualizarUbicacion);
  }

  /* ************************************************************ */
  /* ***** Firebase **** */
  /* ************************************************************ */

  // Registrar
  createDoc<tipo>(data: tipo, enlace: string, idDoc: string) {
    const itemsCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(enlace);
    return itemsCollection.doc(idDoc).set(data);
  }

  // Generar ID
  createIdDoc(): string {
    return this.FireStore.createId();
  }

  // Eliminar
  deleteDoc(path) {
    return this.FireStore.doc(path).delete();
  }

  // Actualizar
  updateDoc(path, data) {
    return this.FireStore.doc(path).update(data);
  }

  // Get consultar
  getDoc<tipo>(path) {
    const doc: AngularFirestoreDocument<tipo> = this.FireStore.doc(path);
    return doc.valueChanges();
  }

  // Get lista
  getCollection<tipo>(path) {
    const itemsCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(path);
    return itemsCollection.valueChanges();
  }

  // Get lista Where
  getCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string, orderParametro: string, orderValue: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .orderBy(orderParametro, orderValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista Multi-Where
  getCollectionMultiWhere<tipo>(path: string, whereParametro: string, whereValue: string[], orderParametro: string, orderValue: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, 'array-contains-any', whereValue)
        .orderBy(orderParametro, orderValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista Where & Limit
  getCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, orderParametro: string, orderValue: any, limitEnd: number, limitStart?: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    if (limitStart === null) {
      dataCollection = this.FireStore.collection<tipo>(
        path, ref =>
        ref.where(whereParametro, '==', whereValue)
          .orderBy(orderParametro, orderValue)
          .limit(limitEnd)
      );
      return dataCollection.valueChanges();
    }

    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .orderBy(orderParametro, orderValue)
        .startAfter(limitStart)
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista Multi-ParametroWhere
  getCollectionMultiParametroWhere<tipo>(path: string, whereParametroOne: string, whereValueOne: string, whereParametroTwo: string, whereValueTwo: string, orderParametro: string, orderValue: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametroOne, '==', whereValueOne)
        .where(whereParametroTwo, '==', whereValueTwo)
        .orderBy(orderParametro, orderValue)
    );
    return dataCollection.valueChanges();
  }

  /* ************************************************************ */
  /* ***** Firebase Ciudad **** */
  /* ************************************************************ */
  // Get lista Where
  getCityCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string, orderParametro: string, orderValue: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('ciudad', '==', this.authCiudad)
        .orderBy(orderParametro, orderValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista Multi-Where
  getCityCollectionMultiWhere<tipo>(path: string, whereParametro: string, whereValue: string[], orderParametro: string, orderValue: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, 'array-contains-any', whereValue)
        .where('ciudad', '==', this.authCiudad)
        .orderBy(orderParametro, orderValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista Where & Limit
  getCityCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, orderParametro: string, orderValue: any, limitEnd: number, limitStart?: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    if (limitStart === null) {
      dataCollection = this.FireStore.collection<tipo>(
        path, ref =>
        ref.where(whereParametro, '==', whereValue)
          .where('ciudad', '==', this.authCiudad)
          .orderBy(orderParametro, orderValue)
          .limit(limitEnd)
      );
      return dataCollection.valueChanges();
    }

    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('ciudad', '==', this.authCiudad)
        .orderBy(orderParametro, orderValue)
        .startAfter(limitStart)
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista Multi-ParametroWhere
  getCityCollectionMultiParametroWhere<tipo>(path: string, whereParametroOne: string, whereValueOne: string, whereParametroTwo: string, whereValueTwo: string, orderParametro: string, orderValue: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametroOne, '==', whereValueOne)
        .where(whereParametroTwo, '==', whereValueTwo)
        .where('ciudad', '==', this.authCiudad)
        .orderBy(orderParametro, orderValue)
    );
    return dataCollection.valueChanges();
  }


  /* ************************************************************ */
  /* ***** Firebase Tienda Virtual **** */
  /* ************************************************************ */

  // Get lista products Where & Limit
  getProductosCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('comercio.ciudad', '==', this.authCiudad)
        .where('cantidad', '>=', 1)
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista productos Where
  getProductosCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('comercio.ciudad', '==', this.authCiudad)
        .where('cantidad', '>=', 1)
    );
    return dataCollection.valueChanges();
  }

  // Get lista products Where & Limit
  getProductosComercioCollectionWhereLimit<tipo>(path: string, idComercio: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('comercio.id', '==', idComercio)
        .where('comercio.estado', '==', 'activo')
        .where('cantidad', '>=', 1)
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista productos Where
  getProductosComercioCollectionWhere<tipo>(path: string, idComercio: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('comercio.id', '==', idComercio)
        .where('comercio.estado', '==', 'activo')
        .where('cantidad', '>=', 1)
    );
    return dataCollection.valueChanges();
  }


  /* ************************************************************ */
  /* ***** Firebase Pedidos **** */
  /* ************************************************************ */

  // Get lista pedidos Where & Limit
  getPedidosCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .orderBy("createdAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  getServiciosPedidosFecha<tipo>(path: string, idUsuario: string, whereParametro: string, whereValue: string, whereParametroDos: string, whereValueDos: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('pedido.cliente.id', '==', idUsuario)
        .where(whereParametro, '>=', whereValue)
        .where(whereParametroDos, '<=', whereValueDos)
    );
    return dataCollection.valueChanges();
  }

  // Get lista pedidos Where
  getPedidosCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista pedidos estado Where
  getPedidosEstadoCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string, whereEstadoParametro: string, whereEstadoValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where(whereEstadoParametro, '==', whereEstadoValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista pedidos Where & Limit
  getAdminPedidosCollectionWhereLimit<tipo>(path: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('comercio.ciudad', '==', this.authCiudad)
        .orderBy("createdAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista pedidos Where
  getAdminPedidosCollectionWhere<tipo>(path: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('comercio.ciudad', '==', this.authCiudad)
    );
    return dataCollection.valueChanges();
  }

  /* ************************************************************ */
  /* ***** Firebase Transportadores **** */
  /* ************************************************************ */

  // Get lista transportadores disponibles
  getTransportadoresDisponibles<tipo>(path: string, vehiculo: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('categoria', '==', vehiculo)
        .where('estado', '==', 'activo')
        .where('transportador.ciudad', '==', this.authCiudad)
        .where('transportador.estado', '==', 'activo')
        .where('transportador.disponible', '==', 'disponible')
    );
    return dataCollection.valueChanges();
  }

  // Get lista transportadores disponibles
  getTransportadoresDisponiblesPost<tipo>(path: string, vehiculo: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('categoria', '==', vehiculo)
        .where('estado', '==', 'activo')
        .where('transportador.ciudad', '==', this.authCiudad)
        .where('transportador.estado', '==', 'activo')
    );
    return dataCollection.valueChanges();
  }


  // Get All lista transportadores disponibles
  getAllTransportadoresDisponibles<tipo>(path: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('estado', '==', 'activo')
        .where('transportador.ciudad', '==', this.authCiudad)
        .where('transportador.estado', '==', 'activo')
        .where('transportador.disponible', 'in', ['disponible', 'en servicio'])
    );
    return dataCollection.valueChanges();
  }



  /* ************************************************************ */
  /* ***** Firebase Encargas **** */
  /* ************************************************************ */

  // Get lista encargas Where & Limit
  getEncargasCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .orderBy("createdAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas Where
  getEncargasCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas Where & Limit
  getEncargasActivasCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'activo')
        .orderBy("createdAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas Where
  getEncargasActivasCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'activo')
    );
    return dataCollection.valueChanges();
  }

  // Get lista servicio activo
  getEncargaServicio<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'activo')
    );
    return dataCollection.valueChanges();
  }

  // Get lista servicio post activo
  getEncargaServicioPost<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'activo')
        .where('en_servicio', '==', true)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas agenda Where
  getAgendaEncargas<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('agendaFecha.dia', '==', this.fechaDia)
        .where('agendaFecha.mes', '==', this.fechaMes)
        .where('agendaFecha.year', '==', this.fechaYear)
        .where('estado', '==', 'activo')
    );
    console.log("SQL ->", this.fechaDia + '-' + this.fechaMes + '-' + this.fechaYear);
    return dataCollection.valueChanges();
  }


  // Get lista encargas Where & Limit
  getAdminEncargasCollectionWhereLimit<tipo>(path: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('vehiculo.transportador.ciudad', '==', this.authCiudad)
        .orderBy("createdAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas Where
  getAdminEncargasCollectionWhere<tipo>(path: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('vehiculo.transportador.ciudad', '==', this.authCiudad)
    );
    return dataCollection.valueChanges();
  }


  // Analisis Encargas
  getAnalisisEncarga<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'finalizado')
    );
    return dataCollection.valueChanges();
  }

  // Analisis Encargas Post
  getAnalisisEncargaPost<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'finalizado')
    );
    return dataCollection.valueChanges();
  }

  getServiciosFecha<tipo>(path: string, idUsuario: string, whereParametro: string, whereValue: string, whereParametroDos: string, whereValueDos: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('vehiculo.transportador.id', '==', idUsuario)
        .where(whereParametro, '>=', whereValue)
        .where(whereParametroDos, '<=', whereValueDos)
    );
    return dataCollection.valueChanges();
  }

  getServiciosCanceladosFecha<tipo>(path: string, idUsuario: string, whereParametro: string, whereValue: string, whereParametroDos: string, whereValueDos: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('vehiculo.transportador.id', '==', idUsuario)
        .where('estado', '==', 'cancelado')
        .where(whereParametro, '>=', whereValue)
        .where(whereParametroDos, '<=', whereValueDos)
    );
    return dataCollection.valueChanges();
  }

  // All Encargas & Agenda
  getEncargasAllCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', 'in', ['finalizado', 'cancelado'])
        .orderBy("createdAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas Where
  getEncargasAllCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', 'in', ['finalizado', 'cancelado'])
    );
    return dataCollection.valueChanges();
  }

  // Get lista servicios agendados activos
  getAgendaEncargaServiciosActivos<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .where('estado', '==', 'activo')
    );
    return dataCollection.valueChanges();
  }

  /* ************************************************************ */
  /* ***** Firebase Vehiculos **** */
  /* ************************************************************ */

  // Get lista encargas Where & Limit
  getVehiculosCollectionWhereLimit<tipo>(path: string, whereParametro: string, whereValue: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista encargas Where
  getVehiculosCollectionWhere<tipo>(path: string, whereParametro: string, whereValue: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where(whereParametro, '==', whereValue)
    );
    return dataCollection.valueChanges();
  }


  /* ************************************************************ */
  /* ***** Firebase Panico **** */
  /* ************************************************************ */

  // Get lista panico activos
  getPanicoCollectionWhere<tipo>(path: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('usuario.ciudad', '==', this.authCiudad)
        .orderBy("createdAt", "desc")
    );
    return dataCollection.valueChanges();
  }

  /* ************************************************************ */
  /* ***** Firebase Central **** */
  /* ************************************************************ */

  // Get lista central Where & Limit
  getAdminCentralCollectionWhereLimit<tipo>(path: string, limitEnd: number) {
    let dataCollection: AngularFirestoreCollection<tipo>;
    dataCollection = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('usuario.ciudad', '==', this.authCiudad)
        .orderBy("updatedAt", "desc")
        .limit(limitEnd)
    );
    return dataCollection.valueChanges();
  }

  // Get lista central Where
  getAdminCentralCollectionWhere<tipo>(path: string) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('usuario.ciudad', '==', this.authCiudad)
    );
    return dataCollection.valueChanges();
  }

  // Get lista agenda transportador
  getAgendaTransportador<tipo>(path: string, transportador: any) {
    const dataCollection: AngularFirestoreCollection<tipo> = this.FireStore.collection<tipo>(
      path, ref =>
      ref.where('vehiculo.transportador.id', '==', transportador)
        .where('estado', '!=', 'finalizado')
    );
    return dataCollection.valueChanges();
  }



  /****************************************/
  /****** Metodos Utilitarios ******/
  /****************************************/
  establecerFecha() {
    this.fechaActual = new Date();

    this.fechaActualObj = this.datepipe.transform(this.fechaActual, 'd/MM/y, h:mm:ss');
    console.log('Fecha actual establecida ->', this.fechaActual);
    console.log('Fecha Obj establecida ->', this.fechaActualObj);

    this.fechaDia = this.datepipe.transform(this.fechaActual, 'd'); // # Dia
    this.fechaMes = this.datepipe.transform(this.fechaActual, 'MM');
    this.fechaYear = this.datepipe.transform(this.fechaActual, 'y');
    this.fechaHora = this.datepipe.transform(this.fechaActual, 'H');
    this.fechaMinuto = this.datepipe.transform(this.fechaActual, 'mm');

    console.log('Fecha text ->',
      this.nameDia(this.fechaActual.getDay()) + ' ' +
      this.fechaDia + ' de ' +
      this.nameMes(parseInt(this.fechaMes) - 1) + '  ' +
      this.fechaMes + ' de ' +
      this.fechaYear
    );
  }

  getFechaActualObj() {
    return this.fechaActualObj;
  }

  getFechaActual() {
    return this.fechaActual;
  }

  nameDia(index) {
    var dia = new Array(7);
    dia[0] = "Domingo";
    dia[1] = "Lunes";
    dia[2] = "Martes";
    dia[3] = "Miércoles";
    dia[4] = "Jueves";
    dia[5] = "Viernes";
    dia[6] = "Sábado";
    return dia[index];
  }

  nameMes(index) {
    var mes = new Array(12);
    mes[0] = "Enero";
    mes[1] = "Febrero";
    mes[2] = "Marzo";
    mes[3] = "Abril";
    mes[4] = "Mayo";
    mes[5] = "Junio";
    mes[6] = "Julio";
    mes[7] = "Agosto";
    mes[8] = "Septiembre";
    mes[9] = "Octubre";
    mes[10] = "Noviembre";
    mes[11] = "Diciembre";
    return mes[index];
  }

  getFechaDia() {
    return this.fechaDia;
  }

  getFechaMes() {
    return this.fechaMes;
  }

  getFechaYear() {
    return this.fechaYear;
  }

  getFechaHora() {
    return this.fechaHora;
  }

  getFechaMinuto() {
    return this.fechaMinuto;
  }

  getCiudad() {
    return this.authCiudad;
  }

  getTRecargaMapa() {
    return this.tiempoRecargaMapa;
  }

  getTRecargaUbicacion() {
    return this.tiempoRecargaUbicacion;
  }


  setUbicacionTransportador(transportador: any) { // Actualizar Ubicación
    //this.actualizarUbicacion = interval(this.getTRecargaUbicacion());
    //this.getParametroUbicacion();
    
    Geolocation.getCurrentPosition().then((res) => {
      console.log('Ubicacion Actual() -> get');
      this.appUbicacion = {
        lat: res.coords.latitude,
        lng: res.coords.longitude
      }
      const data = {
        ubicacion: this.appUbicacion,
        updatedAt: Date.now()
      }
      const path = '/usuarios/' + transportador.id;
      this.updateDoc(path, data).then(res => { // Update Transportador
        const dataVehiculo = {
          transportador: transportador,
          updatedAt: Date.now()
        }
        const pathVehiculo = '/vehiculos/' + transportador.id;
        this.updateDoc(pathVehiculo, dataVehiculo).then(res => { // Update Vehiculo
          console.log("Actualizacion de Ubicacion -> OK :D");
        }).catch(error => {
          console.log(error.message);
        });
      }).catch(error => {
        console.log(error.message);
      });
    });
  }

  getUbicacionApp() {
    return this.appUbicacion;
  }


  getParametroUbicacion() {
    if (this.usuarioApp !== null && this.usuarioApp !== undefined) {// ubicacion
      if (this.usuarioApp.rol === 'transportador') {
        if (this.usuarioApp.disponible === 'disponible' || this.usuarioApp.disponible === 'en servicio') {
          this.setUbicacionTransportador(this.usuarioApp);
        } else {
          console.log('El usuario no esta disponible para que muestre su ubicacion, hasta que vuelva a estar en servicio o disponible');
        }
      } else {
        console.log('No requiere actualizar en tiempo real.');
      }
    }
  }

}
